exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "\r\n.badge-pill {\r\n    font-size: 33%;\r\n    top: -7px;\r\n    position: relative;\r\n    font-weight: 200;\r\n}\r\n\r\n.panel-body {\r\n    background-color: #F8F8F8;\r\n}\r\n\r\n/* overrule vendor styles */\r\n.panel {\r\n    border-radius: 0px;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/app/app.css
// module id = app/components/app/app.css
// module chunks = 0